import { getUrlParam } from "@/utils/url-parse";
import Cookie from "js-cookie";

export const setCartSelectedSkuNoList = (skuNoList: string) => {
  const staticQuery = getUrlParam();
  const openId = Cookie.get("msOpenId");
  if (staticQuery.shopId && openId) {
    localStorage.setItem(`${staticQuery.shopId}:${openId}:selectedSkuObjList`, skuNoList);
  }
};

export const addCartSelectedSkuNo = ({
  activityNo,
  skuNo,
  spuId,
}: {
  activityNo: string;
  skuNo: string;
  spuId: string;
}) => {
  const staticQuery = getUrlParam();
  if (activityNo && skuNo) {
    const openId = Cookie.get("msOpenId");
    if (staticQuery.shopId && openId) {
      const listStr = localStorage.getItem(`${staticQuery.shopId}:${openId}:selectedSkuObjList`);
      let list = JSON.parse(listStr ?? "[]") || [];
      if (list.some(it => it.activityId === activityNo && it.skuId === skuNo)) {
        return;
      }
      list.push({ activityId: activityNo, skuId: skuNo, spuId });
      setCartSelectedSkuNoList(JSON.stringify(list));
    }
  }
};
